import React from "react";
import {ErrorBoundaryRoutes} from "../../components/ErrorBoundaryRoutes";
import {Route} from "react-router-dom";
import {PropositionsList} from "./PropositionsList";
import {ContentPage} from "../../components/ContentPage";
import {PropositionEvaluation} from "./PropositionEvaluation";


export const PropositionsApp = () => {
    return (<ContentPage>
            <ErrorBoundaryRoutes>
                <Route index={true} element={<PropositionsList/>}/>
                <Route path=":uuid" element={<PropositionEvaluation/>}/>
            </ErrorBoundaryRoutes>
        </ContentPage>

    );
};

